import React from 'react'

import { type OpeningHoursProps } from '@/types'
import { useDayTranslations } from '@hooks/useDayTranslations'
import { getOpeningHoursForDay } from '@hooks/useOpeningHours'

interface OpeningDaysProps {
  allOpeningHours: OpeningHoursProps
}

const OpeningDays: React.FC<OpeningDaysProps> = ({ allOpeningHours }) => {
  const { daysOfWeekKeys, daysOfWeekTranslations } = useDayTranslations()

  return (
    <ul className="flex flex-col xl:gap-y-4 gap-y-4">
      {daysOfWeekKeys.map((day, index) => (
        <li
          key={day}
          className="prose grid grid-cols-[77px_1fr] gap-x-6 font-medium"
        >
          <span className="text-deep-black">
            {daysOfWeekTranslations[index]}
          </span>
          <span className="text-grey-dark text-[14px] leading-[18px] text-balance">
            {getOpeningHoursForDay(allOpeningHours, day)}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default OpeningDays
